import type { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';

import { applyTheme, saveTheme, shownTheme } from '../theme.js';

/**
 * Light or dark (sheet: .theme-toggle, SP-UX10.1).
 * `t`: the label in the page's language where that is not the app's (public status page).
 */
export function ThemeToggle({ t: fixedT }: { t?: TFunction } = {}) {
  const { t: appT } = useTranslation();
  const t = fixedT ?? appT;
  return (
    <button
      type="button"
      className="theme-toggle"
      aria-label={t('nav.theme')}
      onClick={() => {
        const next = shownTheme() === 'dark' ? 'light' : 'dark';
        saveTheme(next);
        // The icons follow data-theme through CSS (components.css): nothing to re-render.
        applyTheme(next);
      }}
    >
      <svg
        className="sun"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        aria-hidden="true"
      >
        <circle cx="12" cy="12" r="4" />
        <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
      </svg>
      <svg
        className="moon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        aria-hidden="true"
      >
        <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" />
      </svg>
    </button>
  );
}
